module.exports = __webpack_public_path__ + "static/media/service11.f9557071.jpg";